import { TagsApi } from "../Api";
import { useQuery } from "@tanstack/react-query";
export const useTags = ()=>{
    const tagsApi = new TagsApi();
    const useGetTagsQuery = (pagination, config)=>useQuery([
            "tags",
            pagination
        ], async ()=>await tagsApi.getTags(pagination), {
            refetchOnMount: false,
            ...config
        });
    return {
        useGetTagsQuery
    };
};
